module.exports = __webpack_public_path__ + "img/timerhelp.1569ca81.png";